import { render } from "./License.vue?vue&type=template&id=0291ba28&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"

import "./License.vue?vue&type=style&index=0&id=0291ba28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0291ba28"

export default script